import type React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import type { ComingSoonModules } from "models/product/ProductDetails";

import { buildUrlWithPathParams } from "_helpers/utils/urlBuilder";
import { PLACEHOLDER_PAGE_ROUTES } from "constants/routes";

import { ParagraphLarge } from "styles/elements/Texts";
import { BaseModuleCard } from "../BaseModuleCard/BaseModuleCard";

interface ModuleCardProps {
  productId: number;
  comingSoonModule: ComingSoonModules;
}

export const ComingSoonModuleCard: React.FC<ModuleCardProps> = ({
  productId,
  comingSoonModule,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation("homepage");

  const onCardClick = () => {
    navigate(
      buildUrlWithPathParams(PLACEHOLDER_PAGE_ROUTES.COMING_SOON_MODULE, {
        productId,
        moduleType: comingSoonModule.type,
      }),
    );
  };

  const handleSubscribeNewModules = () => {
    window.open(comingSoonModule.subscriptionUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <BaseModuleCard
      isPlaceholderModule={true}
      dataCy="coming-soon-module-card"
      moduleId={comingSoonModule.type}
      moduleTitle={comingSoonModule.title}
      moduleDescription={comingSoonModule.description}
      extraCardContent={
        <ParagraphLarge fontWeight="bold">
          {t("studentDashboard.comingSoonModules.availabilityNote")}
        </ParagraphLarge>
      }
      actionButtonVariant="primary-outline"
      actionButtonLabel={t("studentDashboard.currentProgressSection.moduleCard.subscribeButton")}
      onCardClick={onCardClick}
      onActionButtonClick={handleSubscribeNewModules}
    />
  );
};
